<template>
  <div>
    <b-row>
      <b-col cols="2">
        <b-button @click.stop="showSelectService" variant="success">{{ $t('Add') }}</b-button>
      </b-col>
      <b-col cols="6">
        <b-form-group :label="$t('Select account')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select v-model="selectedAccount" :options="currentRow.accounts">
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-table small striped hover :items="seviceLinks" :fields="seviceLinksFields" @row-clicked="rowServiceLinkClickHandler">
      <template v-slot:cell(actions)="row">
        <b-button size="sm" @click.stop="ClickOnDeleteServiceButton(row)" id="transparent">
          <b-img :src='deleteDocumentImage' />
        </b-button>
        <b-button size="sm" @click.stop="ClickOnEditServiceButton(row)" id="transparent">
          <b-img :src='editDocumentImage' />
        </b-button>
      </template>
    </b-table>
    <b-modal hide-footer :title="$t('Confirmation')" ref="modalDeleteService">
      <h5>{{ $t('Are you sure you want to delete one of "Service links"?') }}</h5>
      <b-row>
        <b-col>
          <b-button variant="danger" block @click="deleteServiceLink()">Ok</b-button>
        </b-col>
        <b-col>
          <b-button variant="secondary" block @click="hideDeleteService()">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal ref="modalSelectService" hide-footer :title="$t('Select service')">
      <b-table small striped hover
        :items="selectService"
        :fields="selectServiceFields"
        @row-clicked="rowClickHandler"/>
      <b-row>
        <b-col>
          <b-button variant="success" @click.stop="formSelectService" style="float: right; width: 100px">Ok</b-button>
        </b-col>
        <b-col sm="3">
          <b-button variant="secondary" @click="hideSelectService" style="float: right; width: 100px">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal hide-footer ref="modalOneTime" :title="$t('One-time service link')" @hidden="isShowOneTime = false">
      <FormOneTime v-if="isShowOneTime"
      @makeToasts="makeToasts"
      @hideSelectService="hideSelectService"
      @refreshTable="refreshTable"
      :currentUser="currentRow"
      :currentService="currentRowService"
      :selectedAccount="selectedAccount"
      :isEdit="isEdit"/>
    </b-modal>
    <b-modal hide-footer ref="modalPeriodic" :title="$t('Periodic service link')" @hidden="isShowPeriodic = false" size="lg">
      <FormPeriodic v-if="isShowPeriodic"
      @hideSelectService="hideSelectService"
      @refreshTable="refreshTable"
      :currentUser="currentRow"
      :currentService="currentRowService"
      @makeToasts="makeToasts"
      :selectedAccount="selectedAccount"
      :isEdit="isEdit"/>
    </b-modal>
    <b-modal hide-footer ref="modalHotspot" :title="$t('Hotspot service link')" @hidden="isShowHotspot = false" size="lg">
      <FormHotspot v-if="isShowHotspot"
      @hideSelectService="hideSelectService"
      @refreshTable="refreshTable"
      :currentUser="currentRow"
      :currentService="currentRowService"
      @makeToasts="makeToasts"
      :selectedAccount="selectedAccount"
      :isEdit="isEdit"/>
    </b-modal>
    <b-modal hide-footer ref="modalDialup" :title="$t('Dial-up service link')" @hidden="isShowDialup = false" size="lg">
      <FormDialup v-if="isShowDialup"
      @hideSelectService="hideSelectService"
      @refreshTable="refreshTable"
      :currentUser="currentRow"
      :currentService="currentRowService"
      @makeToasts="makeToasts"
      :selectedAccount="selectedAccount"
      :isEdit="isEdit"/>
    </b-modal>
    <b-modal hide-footer ref="modalTelephony" :title="$t('Telephony service link')" @hidden="isShowTelephony = false" size="lg">
      <FormTelephony v-if="isShowTelephony"
      @hideSelectService="hideSelectService"
      @refreshTable="refreshTable"
      :currentUser="currentRow"
      :currentService="currentRowService"
      @makeToasts="makeToasts"
      :selectedAccount="selectedAccount"
      :isEdit="isEdit"/>
    </b-modal>
    <b-modal hide-footer ref="modalIPTraffic" :title="$t('IP traffic service link')" @hidden="isShowTPTraffic = false" size="lg">
      <FormIPTraffic v-if="isShowTPTraffic"
      @hideSelectService="hideSelectService"
      @refreshTable="refreshTable"
      :currentUser="currentRow"
      :currentService="currentRowService"
      @makeToasts="makeToasts"
      :selectedAccount="selectedAccount"
      :isEdit="isEdit"/>
    </b-modal>
    <b-modal hide-footer ref="modalVideo" :title="$t('Video on demand')" @hidden="isShowVideo = false">
      <FormVideo v-if="isShowVideo"
      @hideSelectService="hideSelectService"
      @refreshTable="refreshTable"
      :currentUser="currentRow"
      :currentService="currentRowService"
      @makeToasts="makeToasts"
      :selectedAccount="selectedAccount"
      :isEdit="isEdit"/>
    </b-modal>
    <b-modal hide-footer ref="modalIPTV" :title="$t('IPTV service link')" @hidden="isShowIPTV = false">
      <FormIPTV v-if="isShowIPTV"
      @hideSelectService="hideSelectService"
      @refreshTable="refreshTable"
      :currentUser="currentRow"
      :currentService="currentRowService"
      @makeToasts="makeToasts"
      :selectedAccount="selectedAccount"
      :isEdit="isEdit"/>
    </b-modal>
  </div>
</template>

<script>
import axiosInstance from '@/utils/api.js'

import FormOneTime from './formOnce.vue'
import FormPeriodic from './formPeriodic.vue'
import FormHotspot from './formHotspot.vue'
import FormDialup from './formDialup.vue'
import FormTelephony from './formTelephony.vue'
import FormIPTraffic from './formIPTraffic.vue'
import FormVideo from './formVOD.vue'
import FormIPTV from './formIPTV.vue'

export default {
  components: {
    FormOneTime,
    FormPeriodic,
    FormHotspot,
    FormDialup,
    FormTelephony,
    FormIPTraffic,
    FormVideo,
    FormIPTV
  },
  props: {
    currentRow: null
  },
  data () {
    return {
      isEdit: false,
      selectedAccount: null,
      isShowOneTime: false,
      isShowPeriodic: false,
      isShowHotspot: false,
      isShowDialup: false,
      isShowTelephony: false,
      isShowTPTraffic: false,
      isShowVideo: false,
      isShowIPTV: false,
      service_id: null,
      deleteDocumentImage: require('@/assets/img/document_delete.png'),
      editDocumentImage: require('@/assets/img/document_edit.png'),
      seviceLinks: [],
      seviceLinksFields: [
        { key: 'service_id', label: this.$i18n.t('Service ID'), sortable: true, sortDirection: 'desc' },
        { key: 'service_name', label: this.$i18n.t('Name'), sortable: true },
        { key: 'service_type_name', label: this.$i18n.t('Type name'), sortable: true },
        { key: 'in_tariff', label: this.$i18n.t('In tarrif'), sortable: true },
        { key: 'cost', label: this.$i18n.t('Cost'), sortable: true },
        { key: 'service_link_id', label: this.$i18n.t('Service link ID'), sortable: true },
        { key: 'accounting_period_id', label: this.$i18n.t('Accounting period ID'), sortable: true },
        { key: 'actions', label: this.$i18n.t('Actions') }
      ],
      selectService: [],
      selectServiceFields: [
        { key: 'service_id', label: this.$i18n.t('Service ID'), sortable: true },
        { key: 'service_name', label: this.$i18n.t('Service name'), sortable: true },
        { key: 'service_type_name', label: this.$i18n.t('Service type'), sortable: true },
        { key: 'comment', label: this.$i18n.t('Comment'), sortable: true }
      ],
      currentRowServiceLink: null,
      currentRowService: null,
      is_dev: process.env.NODE_ENV === 'development'
    }
  },
  methods: {
    formSelectService () {
      if (!this.currentRowService) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select service'), 'Error')
        return
      }
      switch (this.currentRowService.service_type) {
        case 1:
          this.showOneTime()
          this.$refs.modalSelectService.hide()
          break
        case 2:
          this.showPeriodic()
          this.$refs.modalSelectService.hide()
          break
        case 3:
          this.showIPTraffic()
          this.$refs.modalSelectService.hide()
          break
        case 4:
          this.showHotspot()
          this.$refs.modalSelectService.hide()
          break
        case 5:
          this.showDialup()
          this.$refs.modalSelectService.hide()
          break
        case 6:
          this.showTelephony()
          this.$refs.modalSelectService.hide()
          break
        case 8:
          this.showIPTV()
          this.$refs.modalSelectService.hide()
          break
        case 9:
          this.showVideo()
          this.$refs.modalSelectService.hide()
          break
      }
    },
    showEditService () {
      if (!this.currentRowServiceLink) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select service'), 'Error')
        return
      }
      this.currentRowService = this.currentRowServiceLink
      switch (this.currentRowService.service_type) {
        case 1:
          this.showOneTimeEdit()
          break
        case 2:
          this.showPeriodicEdit()
          break
        case 3:
          this.showIPTrafficEdit()
          break
        case 4:
          this.showHotspotEdit()
          break
        case 5:
          this.showDialupEdit()
          break
        case 6:
          this.showTelephonyEdit()
          break
        case 8:
          this.showIPTVEdit()
          break
        case 9:
          this.showVideoEdit()
          break
      }
    },
    showOneTime () {
      this.isEdit = false
      this.isShowOneTime = true
      this.$refs.modalOneTime.show()
    },
    showOneTimeEdit () {
      this.isEdit = true
      this.isShowOneTime = true
      this.$refs.modalOneTime.show()
    },
    showPeriodic () {
      this.isEdit = false
      this.isShowPeriodic = true
      this.$refs.modalPeriodic.show()
    },
    showPeriodicEdit () {
      this.isEdit = true
      this.isShowPeriodic = true
      this.$refs.modalPeriodic.show()
    },
    showHotspot () {
      this.isEdit = false
      this.isShowHotspot = true
      this.$refs.modalHotspot.show()
    },
    showHotspotEdit () {
      this.isEdit = true
      this.isShowHotspot = true
      this.$refs.modalHotspot.show()
    },
    showDialup () {
      this.isEdit = false
      this.isShowDialup = true
      this.$refs.modalDialup.show()
    },
    showDialupEdit () {
      this.isEdit = true
      this.isShowDialup = true
      this.$refs.modalDialup.show()
    },
    showTelephony () {
      this.isEdit = false
      this.isShowTelephony = true
      this.$refs.modalTelephony.show()
    },
    showTelephonyEdit () {
      this.isEdit = true
      this.isShowTelephony = true
      this.$refs.modalTelephony.show()
    },
    showIPTraffic () {
      this.isEdit = false
      this.isShowTPTraffic = true
      this.$refs.modalIPTraffic.show()
    },
    showIPTrafficEdit () {
      this.isEdit = true
      this.isShowTPTraffic = true
      this.$refs.modalIPTraffic.show()
    },
    showVideo () {
      this.isEdit = false
      this.isShowVideo = true
      this.$refs.modalVideo.show()
    },
    showVideoEdit () {
      this.isEdit = true
      this.isShowVideo = true
      this.$refs.modalVideo.show()
    },
    showIPTV () {
      this.isEdit = false
      this.isShowIPTV = true
      this.$refs.modalIPTV.show()
    },
    showIPTVEdit () {
      this.isEdit = true
      this.isShowIPTV = true
      this.$refs.modalIPTV.show()
    },
    async showSelectService () {
      this.$refs.modalSelectService.show()
      await axiosInstance.get(this.$store.getters.API_TARIFFING_SERVICES).then(response => { this.selectService = response.data })
      this.selectService = this.selectService.filter(function (value) {
        return value.parent_id === 0 && value.tariff_id === 0
      })
    },
    hideSelectService () {
      this.$refs.modalSelectService.hide()
      this.$refs.modalOneTime.hide()
      this.$refs.modalPeriodic.hide()
      this.$refs.modalHotspot.hide()
      this.$refs.modalDialup.hide()
      this.$refs.modalTelephony.hide()
      this.$refs.modalIPTraffic.hide()
      this.$refs.modalVideo.hide()
      this.$refs.modalIPTV.hide()
    },
    hideDeleteService () {
      this.$refs.modalDeleteService.hide()
    },
    ClickOnEditServiceButton (row) {
      this.currentRowServiceLink = row.item
      this.showEditService()
    },
    ClickOnDeleteServiceButton (row) {
      this.currentRowServiceLink = row.item
      this.$refs.modalDeleteService.show()
    },
    async deleteServiceLink () {
      if (this.currentRowServiceLink) {
        if (this.currentRowServiceLink.service_type === 3) {
          let response = await this.$store.dispatch('Tariffing/DELETE_RADIUS_SESSION', this.currentRowServiceLink.service_link_id).then(response => { return response.data })
          if (response.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          }
        }
        axiosInstance.delete(this.$store.getters.API_USERS_SERVICE_LINKS, {data: { 'slink_id': this.currentRowServiceLink.service_link_id }}).then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            this.$root.$emit('makeToasts')
            this.$refs.modalDeleteService.hide()
            this.reloadServices()
          }
        })
      }
    },
    rowServiceLinkClickHandler (row) {
      if (this.currentRowServiceLink) {
        this.currentRowServiceLink._rowVariant = ''
      }
      this.currentRowServiceLink = row
      this.$set(this.currentRowServiceLink, '_rowVariant', 'info')
    },
    rowClickHandler (row) {
      if (this.currentRowService) {
        this.currentRowService._rowVariant = ''
      }
      this.currentRowService = row
      this.$set(this.currentRowService, '_rowVariant', 'info')
    },
    refreshTable () {
      this.reloadServices()
    },
    makeToasts (variant, body, title) {
      this.$root.$emit('makeToasts', variant, body, title)
    },
    load () {
      this.selectedAccount = this.currentRow.accounts.length ? this.currentRow.accounts[0] : null
    },
    async reloadServices () {
      if (this.selectedAccount) {
        this.seviceLinks = await axiosInstance.get(this.$store.getters.API_USERS_SERVICE_LINKS + '?account_id=' + this.selectedAccount).then(response => { return response.data })
      }
    }
  },
  watch: {
    selectedAccount: function () {
      this.reloadServices()
    }
  },
  mounted () {
    this.load()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/serviceLinks/main.vue